import React from 'react';

function Footer() {
  return (
    <footer className="footer">
      <p>© 2025 PreciseDraft.ai All rights reserved.</p>
    </footer>
  );
}

export default Footer;
